import { INTERCOM_APP_ID } from 'Config';

const onLoad = callback => {
  const waitForIntercom = setInterval(() => {
    if (!window.Intercom) {
      return;
    }
    callback();
    clearInterval(waitForIntercom);
  }, 100);
};

const safeIntercom = callback => {
  if (window.Intercom) {
    callback();
  }
};

export const chatIdentify = (userId, hash) => {
  safeIntercom(() =>
    window.Intercom('boot', {
      app_id: INTERCOM_APP_ID,
      user_id: userId,
      user_hash: hash,
    })
  );
};

export const updateChat = () => {
  const time = parseInt(new Date().getTime() / 1000, 10);
  onLoad(() => window.Intercom('update', { last_request_at: time }));
};

export const showChat = () => {
  safeIntercom(() => window.Intercom('show'));
};

export const hideChat = () => {
  safeIntercom(() => window.Intercom('hide'));
};

export const hideLauncher = () => {
  safeIntercom(() => window.Intercom('update', { hide_default_launcher: true }));
};

export const showChatMessages = () => {
  safeIntercom(() => window.Intercom('showMessages'));
};

export const chatLogout = () => {
  safeIntercom(() => window.Intercom('shutdown'));
};

export const showChatWithMessage = ({ message }) => {
  safeIntercom(() => window.Intercom('showNewMessage', message));
};
